// @ts-nocheck
/* eslint-disable @typescript-eslint/camelcase */
import React, { FC } from 'react'
import { Waypoint } from 'react-waypoint'

/**
 * Scroll tracking component, currently just for the masthead.
 */
export const ScrollTracking: FC<{}> = () => (
  // @ts-ignore
  <Waypoint
    scrollableAncestor={window}
    onLeave={({ currentPosition }) => {
      if (currentPosition === Waypoint.above) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'Interactions',
          event_action: 'vertical-scroll',
          event_label: 'startReading'
        })
      }
    }}
  /> 
)
